@use "~theme/typography";
@use "~theme/breakpoints";

.footer {
  background-color: rgba(85,103,120,0.05);
  border-top: 1px solid var(--blue-01-at-30);
  padding: 8px;
  display: block;
  overflow: auto;
  font-size: .875rem;
  letter-spacing: 1px;
  flex-direction: row;
  align-items: flex-end;
  overflow: hidden;
  @include breakpoints.desktop {
    height: 40px;
  }
}

.leftContainer {
    width: 100%;
    float: initial;
    text-align: center;
    @include breakpoints.desktop {
        width: 30%;
        float: left;
        text-align: initial;
    }
}

.rightContainer {
    float: initial;
    margin-top: 5px;
    @include breakpoints.desktop {
        float: right;        
    }

    ul {
        margin: 0px;
        font-size: 1.000em;
    }
    li {
        float: initial;
        text-align: center;
        height: 30px;
        background: none;
        list-style: none;
        list-style-image: none;
        padding: 0px 15px;
        @include breakpoints.desktop {
            float: left;
            text-align: initial;
            height: initial;  
        }

        a {
            text-decoration: none;
            cursor: pointer;
            color: inherit;
        }
    }
}

.copyRight {
    margin-left: 10px;
    font-weight: bold;
    text-align: center;
    padding: 5px 0px 0px 0px;
    @include breakpoints.desktop {
        text-align: left;
    }
}